module.exports = __webpack_public_path__ + "36386dea043cb6bbb201a5ffb731b336.svg";